
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_2qdw9_l6s7s_9",
  "refresh": "awsui_refresh_2qdw9_l6s7s_45",
  "root-no-actions": "awsui_root-no-actions_2qdw9_l6s7s_45",
  "root-variant-h2": "awsui_root-variant-h2_2qdw9_l6s7s_48",
  "root-variant-h3": "awsui_root-variant-h3_2qdw9_l6s7s_48",
  "root-has-description": "awsui_root-has-description_2qdw9_l6s7s_48",
  "root-variant-h1": "awsui_root-variant-h1_2qdw9_l6s7s_57",
  "main": "awsui_main_2qdw9_l6s7s_67",
  "no-wrap": "awsui_no-wrap_2qdw9_l6s7s_77",
  "main-variant-h1": "awsui_main-variant-h1_2qdw9_l6s7s_83",
  "actions": "awsui_actions_2qdw9_l6s7s_91",
  "actions-centered": "awsui_actions-centered_2qdw9_l6s7s_96",
  "actions-variant-h1": "awsui_actions-variant-h1_2qdw9_l6s7s_99",
  "actions-variant-h2": "awsui_actions-variant-h2_2qdw9_l6s7s_103",
  "actions-variant-h3": "awsui_actions-variant-h3_2qdw9_l6s7s_107",
  "title": "awsui_title_2qdw9_l6s7s_123",
  "title-variant-h1": "awsui_title-variant-h1_2qdw9_l6s7s_128",
  "title-variant-h2": "awsui_title-variant-h2_2qdw9_l6s7s_135",
  "title-variant-h3": "awsui_title-variant-h3_2qdw9_l6s7s_141",
  "title-in-expandable-section": "awsui_title-in-expandable-section_2qdw9_l6s7s_154",
  "virtual-space": "awsui_virtual-space_2qdw9_l6s7s_166",
  "info": "awsui_info_2qdw9_l6s7s_172",
  "description": "awsui_description_2qdw9_l6s7s_176",
  "description-variant-h1": "awsui_description-variant-h1_2qdw9_l6s7s_183",
  "description-variant-h2": "awsui_description-variant-h2_2qdw9_l6s7s_187",
  "description-variant-h3": "awsui_description-variant-h3_2qdw9_l6s7s_194",
  "heading": "awsui_heading_2qdw9_l6s7s_205",
  "heading-variant-h1": "awsui_heading-variant-h1_2qdw9_l6s7s_230",
  "heading-variant-h2": "awsui_heading-variant-h2_2qdw9_l6s7s_235",
  "heading-variant-h3": "awsui_heading-variant-h3_2qdw9_l6s7s_240",
  "heading-text": "awsui_heading-text_2qdw9_l6s7s_246",
  "heading-text-variant-h1": "awsui_heading-text-variant-h1_2qdw9_l6s7s_249",
  "heading-text-variant-h2": "awsui_heading-text-variant-h2_2qdw9_l6s7s_258",
  "heading-text-variant-h3": "awsui_heading-text-variant-h3_2qdw9_l6s7s_267",
  "counter": "awsui_counter_2qdw9_l6s7s_277"
};
  